const doc = [({"se":({"js":({"routes":({"admin":({"users":({"school_roles":({})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;